export default __webpack_public_path__ + "static/media/filter-1.4efb1f21.jpg";